/* global gsap */
import { useRef, useState, useEffect } from 'react';
import SplitText from 'gsap/SplitText';
import FontFaceObserver from 'fontfaceobserver';

const fontObserver = new FontFaceObserver('ABCGintoNordCondensed Bold', {
  weight: 400,
});

export default () => {
  const ref = useRef<HTMLElement>(null);
  const animation = useRef<GsapTimeline | null>(null);
  const [font, setFont] = useState(false);
  const [image, setImage] = useState(false);

  function animate() {
    if (animation.current) {
      animation.current.play();
    }
  }

  useEffect(() => {
    const img = ref.current!.querySelector('.image');
    const heading = ref.current!.querySelectorAll('h1');
    const text = new SplitText(heading, { type: 'words' });
    const excerpt = ref.current!.querySelectorAll('.text p, .text .copyright');

    animation.current = gsap.timeline({
      delay: 0.2,
      paused: true,
      onComplete: () => {
        text.revert();
      },
    });

    animation.current
      .fromTo(
        img,
        1,
        { opacity: 0, y: 5 },
        { opacity: 1, y: 0, clearProps: true }
      )
      .fromTo(
        text.words,
        1,
        { opacity: 0 },
        {
          opacity: 1,
          y: 0,
          stagger: 0.1,
          ease: 'power1.inOut',
        },
        '-=0.8'
      )
      .fromTo(
        excerpt,
        1,
        { opacity: 0 },
        {
          opacity: 1,
          y: 0,
          stagger: 0.1,
          ease: 'power1.inOut',
        },
        '-=0.8'
      );

    return () => {
      animation.current!.pause();
      animation.current!.kill();
      animation.current = null;
    };
  }, []);

  useEffect(() => {
    let cancel = false;

    fontObserver.load(null, 3000).then(() => {
      if (!cancel) {
        setFont(true);
      }
    });

    return () => {
      cancel = true;
    };
  }, []);

  useEffect(() => {
    const image = ref.current!.querySelector('img')!;

    function onLoad() {
      setImage(true);
    }

    image.addEventListener('load', onLoad);
    image.addEventListener('error', onLoad);

    if (image.complete && image.naturalHeight !== 0) {
      setImage(true);
    }

    return () => {
      image.removeEventListener('load', onLoad);
      image.removeEventListener('error', onLoad);
    };
  }, []);

  useEffect(() => {
    if (font && image) {
      animate();
    }
  }, [font, image]);

  return [ref, animate];
};
